export default {
	getAll(datafield) {},
	getAllServicesByBrand() {},
	getAllAreaByService() {},
	getAllLocationPatient() {},
	getAllTypeService() {},
}
